/**
 * translationEngine.js — binds the reusable i18n engine to DailyOps' Firestore cache.
 *
 * The generic auto-translate logic lives in src/i18n (createI18n → useEngine); this
 * file just supplies the shared, cross-device cache collection (TRANSLATIONS_COLLECTION).
 * Kept apart from i18n/index.js so that stays Firebase-free (and its unit tests
 * need no Firestore). DailyOps.js: `const engine = useTranslationEngine();`.
 */
import { createFirestoreCache } from '../../../i18n/firestoreCache';
import { TRANSLATIONS_COLLECTION } from '../config/constants';
import { useEngine, normTerm } from './index';

// One shared cache doc per item, keyed by normalized English name; staff-gated by rules.
const opsCache = createFirestoreCache(TRANSLATIONS_COLLECTION, normTerm);

export const useTranslationEngine = () => useEngine(opsCache);
